import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Zap, Gift } from "lucide-react";

/**
 * Credit package card for purchasing AI credits.
 */
export default function CreditPackageCard({ pkg, onPurchase, loading }) {
  const hasBonus =
    pkg.bonus_credits != null && Number(pkg.bonus_credits) > 0;
  const totalCredits =
    Number(pkg.credits) + (hasBonus ? Number(pkg.bonus_credits) : 0);

  return (
    <Card className="relative flex flex-col hover:shadow-lg transition-shadow border-borderDefault">
      {hasBonus && (
        <div className="absolute -top-2 -right-2 z-10">
          <Badge variant="success" className="flex items-center gap-1">
            <Gift className="w-3 h-3" />+{pkg.bonus_credits} bonus
          </Badge>
        </div>
      )}

      <CardContent className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-3">
          <Zap className="w-5 h-5 text-primary" />
          <h4 className="font-semibold text-textPrimary">{pkg.name}</h4>
        </div>

        <div className="mb-3">
          <span className="text-2xl font-bold text-textPrimary">
            {totalCredits.toLocaleString()}
          </span>
          <span className="text-sm text-textSecondary ml-1.5">credits</span>
        </div>

        {pkg.description && (
          <p className="text-sm text-textSecondary mb-3 flex-1">
            {pkg.description}
          </p>
        )}

        <div className="mt-auto pt-2">
          <p className="text-lg font-semibold text-primary mb-2">
            ${Number(pkg.price).toFixed(2)}
          </p>
          <Button
            size="sm"
            className="w-full"
            onClick={() => onPurchase(pkg)}
            disabled={loading}
          >
            {loading ? "Processing..." : "Purchase"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
